import React from 'react';
const Gallery = () => {
  // Sample gallery items
  const galleryItems = [{
    id: 1,
    image: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80',
    alt: 'Köögimööbli paigaldus'
  }, {
    id: 2,
    image: 'https://images.unsplash.com/photo-1631679706909-1844bbd07221?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80',
    alt: 'Garderoobikapi montaaž'
  }, {
    id: 3,
    image: 'https://images.unsplash.com/photo-1560185007-5f0bb1866cab?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80',
    alt: 'Elutoamööbli paigaldus'
  }, {
    id: 4,
    image: 'https://images.unsplash.com/photo-1594026112284-02bb6f3352fe?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80',
    alt: 'Kontorisisustuse montaaž'
  }, {
    id: 5,
    image: 'https://images.unsplash.com/photo-1600210492493-0946911123ea?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80',
    alt: 'Magamistoamööbli paigaldus'
  }, {
    id: 6,
    image: 'https://images.unsplash.com/photo-1505691938895-1758d7feb511?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=80',
    alt: 'Vannitoamööbli montaaž'
  }];
  return <section id="galerii" className="py-16 bg-white" data-id="element-113">
      <div className="container mx-auto px-4" data-id="element-114">
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-900" data-id="element-115">
          Meie tööd
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6" data-id="element-116">
          {galleryItems.map(item => <div key={item.id} className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition duration-300" data-id="element-117">
              <img src={item.image} alt={item.alt} className="w-full h-64 object-cover hover:scale-105 transition duration-500" data-id="element-118" />
            </div>)}
        </div>
        <div className="text-center mt-10" data-id="element-119">
          <button className="bg-blue-900 text-white py-2 px-6 rounded-md hover:bg-blue-800 transition duration-300" data-id="element-120">
            Vaata rohkem töid
          </button>
        </div>
      </div>
    </section>;
};
export default Gallery;